module.exports = __webpack_public_path__ + "static/media/icon_calendar_active.a2175e8c.svg";